/**
 * @generated SignedSource<<c0c95cc20cebc7ca655a1c477786a970>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberOnboardingDownloadMobileAppContentFragment$data = {
  readonly content: {
    readonly " $fragmentSpreads": FragmentRefs<"InlineContentHeroSectionFragment">;
  };
  readonly id: string;
  readonly " $fragmentType": "MemberOnboardingDownloadMobileAppContentFragment";
};
export type MemberOnboardingDownloadMobileAppContentFragment$key = {
  readonly " $data"?: MemberOnboardingDownloadMobileAppContentFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberOnboardingDownloadMobileAppContentFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberOnboardingDownloadMobileAppContentFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "content",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "InlineContentHeroSectionFragment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentUsage",
  "abstractKey": null
};

(node as any).hash = "7ff3ad6731dc5e0a9441a0b82578b684";

export default node;
